/* file: assets/j_spend-gifts.js */
/******* SPEND GIFTS (CHOICE ONLY) — ES5 SAFE + SINGLETON FETCH + DEBOUNCE + A11Y + DIAG *******/

(function () {
  /* ===== 0) LOG TOGGLES ===== */
  var JSG_DEBUG = false;  // set by snippet config.debug
  var JSG_TRACE = false;  // set true only when diagnosing

  console.log("Cart Spend Gifts Active");

  function jsgLog(level) {
    if (!JSG_DEBUG) return;
    var args = Array.prototype.slice.call(arguments, 1);
    (console[level] || console.log).apply(console, ['[JSG]'].concat(args));
  }
  function jsgTrace() {
    if (!JSG_TRACE) return;
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, ['[JSG:TRACE]'].concat(args));
  }

  /* ===== 1) SINGLETON CART FETCH + DEBOUNCE ===== */
  var __jsgRefreshTimer = null;
  var __jsgCartFetchInFlight = null;
  var __jsgIsRunning = false;
  var __jsgLastRunAt = 0;

  function jsgDebouncedRefresh(delay) {
    if (typeof delay !== 'number') delay = 120;
    if (__jsgRefreshTimer) cancelAnimationFrame(__jsgRefreshTimer);
    __jsgRefreshTimer = requestAnimationFrame(function () {
      setTimeout(function () { jsgRefresh(); }, delay);
    });
  }

  function jsgGetCart() {
    if (__jsgCartFetchInFlight) return __jsgCartFetchInFlight;
    __jsgCartFetchInFlight = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function (err) { jsgLog('error', 'GET /cart.js failed', err); throw err; })
      .finally(function () { __jsgCartFetchInFlight = null; });
    return __jsgCartFetchInFlight;
  }

  /* ===== 2) DOM + CONFIG PARSE ===== */
  var jsgRefs = {
    container: null,
    unlock: null,
    msg: null,
    btn: null,
    cfg: null
  };

  function jsgParseConfigFrom(el) {
    if (!el || !el.dataset || !el.dataset.config) return null;
    try { return JSON.parse(el.dataset.config); }
    catch (e) { return null; }
  }

  function jsgInitRefs(force) {
    if (jsgRefs.container && force !== true) {
      try { if (document.body.contains(jsgRefs.container)) return; } catch (_) {}
    }

    jsgRefs.container = document.querySelector('.j_sg-container') || null;
    jsgRefs.cfg = jsgParseConfigFrom(jsgRefs.container);

    jsgRefs.unlock = jsgRefs.container ? jsgRefs.container.querySelector('#j_sg-unlock') : null;
    jsgRefs.msg = jsgRefs.container ? jsgRefs.container.querySelector('.j_sg-msg') : null;
    jsgRefs.btn = jsgRefs.container ? jsgRefs.container.querySelector('.j_sg-choose') : null;

    // config-driven logs
    if (jsgRefs.cfg && jsgRefs.cfg.debug) {
      JSG_DEBUG = true;
      JSG_TRACE = true;
    }

    jsgTrace('initRefs', {
      hasContainer: !!jsgRefs.container,
      hasCfg: !!jsgRefs.cfg,
      hasUnlock: !!jsgRefs.unlock,
      hasMsg: !!jsgRefs.msg,
      hasBtn: !!jsgRefs.btn
    });
  }

  function jsgAccessAllowed(access, customerLogged) {
    var a = String(access || 'everyone');
    if (a === 'everyone') return true;
    if (a === 'logged') return !!customerLogged;
    if (a === 'general') return !customerLogged;
    return true;
  }

  /* ===== 3) A11Y SHOW/HIDE + ANIMATION ===== */
  function jsgSetInert(el, value) {
    if (!el) return;
    try { el.inert = !!value; } catch (e) {}
    if (value) el.setAttribute('inert', '');
    else el.removeAttribute('inert');
  }

  function jsgHideSection(el) {
    if (!el) return;
    // animate out first (CSS can transition opacity/height with .is-visible)
    el.classList.remove('is-visible');
    setTimeout(function () {
      jsgSetInert(el, true);
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    }, 180);
  }

  function jsgShowSection(el) {
    if (!el) return;
    jsgSetInert(el, false);
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');

    // next frame so transitions apply
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });
  }

  /* ===== 4) SPEND SUBTOTAL (EXCLUDING PROMO/GIFT LINES) ===== */
  function jsgIsSpendExcludedLine(item) {
    if (!item) return false;
    var p = item.properties || {};

    // Rewards module flags
    if (p._reward1 === 1 || p._reward1 === '1' || p._reward1 === true || p._reward1 === 'true') return true;
    if (p._reward2 === 1 || p._reward2 === '1' || p._reward2 === true || p._reward2 === 'true') return true;
    if (p._reward3 === 1 || p._reward3 === '1' || p._reward3 === true || p._reward3 === 'true') return true;

    // Legacy reward flags
    if (p._mystery === 1 || p._mystery === '1' || p._mystery === true || p._mystery === 'true') return true;
    if (p.mystery === 1 || p.mystery === '1' || p.mystery === true || p.mystery === 'true') return true;
    if (p._premium === 1 || p._premium === '1' || p._premium === true || p._premium === 'true') return true;

    // Cart Gifts (buy X get gift) flags
    if (p._jcg_gift === 1 || p._jcg_gift === '1' || p._jcg_gift === true || p._jcg_gift === 'true') return true;

    return false;
  }

  function jsgGetSpendSubtotal(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (i) {
      if (jsgIsSpendExcludedLine(i)) return;
      var lp = (i.line_price != null) ? Number(i.line_price) : (Number(i.price || 0) * Number(i.quantity || 1));
      sum += lp;
    });
    return sum;
  }

  /* ===== 5) TIER RESOLUTION ===== */
  function jsgClamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function jsgResolveEligibleQty(totalCents, tiers, maxQty) {
    if (!Array.isArray(tiers) || !tiers.length) return 0;

    var list = tiers
      .map(function (t) {
        return { amount: Number(t && t.amount || 0), qty: Number(t && t.qty || 0) };
      })
      .filter(function (t) { return t.amount > 0 && t.qty > 0; })
      .sort(function (a, b) { return a.amount - b.amount; });

    if (!list.length) return 0;

    var bestQty = 0;
    for (var i = 0; i < list.length; i++) {
      if (totalCents >= list[i].amount) bestQty = list[i].qty;
    }

    bestQty = jsgClamp(bestQty, 0, Number(maxQty || 5) || 5);
    return bestQty;
  }

  /* ===== 6) TEMPLATE COPY (%qty% / %remaining% / %product%) ===== */
  function jsgApplyTemplate(tpl, data) {
    tpl = String(tpl || '');
    data = data || {};
    return tpl
      .replace(/%qty%/gi, String(data.qty != null ? data.qty : ''))
      .replace(/%remaining%/gi, String(data.remaining != null ? data.remaining : ''))
      .replace(/%product%/gi, String(data.product != null ? data.product : ''));
  }

  /* ===== 7) COLLECTION CACHE (PRODUCT HANDLES MAP) ===== */
  var __jsgCollectionCache = {}; // handle -> { handlesMap: {handle:true}, title: '' }
  var __jsgCollectionFetchInFlight = {};

  function jsgFetchCollectionProducts(handle) {
    handle = String(handle || '').toLowerCase();
    if (!handle) return Promise.reject(new Error('missing collection handle'));

    if (__jsgCollectionCache[handle]) return Promise.resolve(__jsgCollectionCache[handle]);
    if (__jsgCollectionFetchInFlight[handle]) return __jsgCollectionFetchInFlight[handle];

    // Shopify collections products.json supports pagination via "page"
    var result = { handlesMap: {}, title: '' };
    var page = 1;
    var per = 250;

    function fetchPage() {
      var url = '/collections/' + handle + '/products.json?limit=' + per + '&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var products = (json && json.products) ? json.products : [];
          for (var i = 0; i < products.length; i++) {
            var h = String(products[i].handle || '').toLowerCase();
            if (h) result.handlesMap[h] = true;
          }
          if (!result.title && products.length && products[0] && products[0].vendor != null) {
            // title isn’t provided in products.json; we’ll keep cfg.product_name anyway
          }
          if (products.length === per) {
            page += 1;
            return fetchPage();
          }
          return result;
        });
    }

    __jsgCollectionFetchInFlight[handle] = fetchPage()
      .then(function (res) {
        __jsgCollectionCache[handle] = res;
        delete __jsgCollectionFetchInFlight[handle];
        jsgTrace('collection loaded', handle, 'count=', Object.keys(res.handlesMap).length);
        return res;
      })
      .catch(function (e) {
        delete __jsgCollectionFetchInFlight[handle];
        throw e;
      });

    return __jsgCollectionFetchInFlight[handle];
  }

  /* ===== 8) CLAIMED COUNT (FREE OR TAGGED) ===== */
  function jsgIsClaimedGiftLine(item, handlesMap) {
    if (!item) return false;

    var h = String(item.handle || '').toLowerCase();
    if (!handlesMap || !handlesMap[h]) return false;

    var p = item.properties || {};

    // if auto-discount already applied:
    var lp = (item.final_line_price != null) ? Number(item.final_line_price)
      : (item.line_price != null) ? Number(item.line_price)
      : 999999;

    if (lp === 0) return true;

    // if we tagged it at add-to-cart time:
    if (p._spend_gift === '1' || p._spend_gift === 1 || p._spend_gift === true || p._spend_gift === 'true') return true;

    return false;
  }

  function jsgCountClaimedQtyFromCollection(cart, handlesMap) {
    var count = 0;
    (cart.items || []).forEach(function (i) {
      if (jsgIsClaimedGiftLine(i, handlesMap)) {
        count += Number(i.quantity || 0);
      }
    });
    return count;
  }

  /* ===== 9) AUTO-TAGGER ON COLLECTION PAGE (FORM + FETCH PATCH) ===== */
  function jsgGetQueryParam(name) {
    try {
      var s = window.location.search || '';
      var m = s.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function jsgShouldAutoTagFromUrl(cfg) {
    // We only auto-tag when user arrived via our CTA
    // Example: /collections/all-pigments?jsg=1
    var flag = jsgGetQueryParam('jsg');
    if (String(flag) !== '1') return false;

    // optional safety: ensure we’re on the configured collection
    // Many themes use /collections/{handle} as the page URL
    var handle = String(cfg && cfg.collection_handle || '').toLowerCase();
    if (!handle) return true;

    var path = String(window.location.pathname || '').toLowerCase();
    if (path.indexOf('/collections/' + handle) !== -1) return true;

    // if user is on product page, still allow if they came from CTA
    return true;
  }

  function jsgInjectIntoForms() {
    jsgInitRefs(true);
    var cfg = jsgRefs.cfg || {};
    if (!jsgShouldAutoTagFromUrl(cfg)) return;

    var forms = document.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]');
    if (!forms || !forms.length) return;

    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];

      // avoid duplicates
      if (f.querySelector('input[name="properties[_spend_gift]"]')) continue;

      var i1 = document.createElement('input');
      i1.type = 'hidden';
      i1.name = 'properties[_spend_gift]';
      i1.value = '1';

      var i2 = document.createElement('input');
      i2.type = 'hidden';
      i2.name = 'properties[_spend_gift_collection]';
      i2.value = String(cfg.collection_handle || '');

      f.appendChild(i1);
      f.appendChild(i2);
    }

    jsgTrace('auto-tag injected into ATC forms', forms.length);
  }

  var __jsgFetchPatched = false;
  function jsgPatchFetchAddToCart() {
    if (__jsgFetchPatched) return;
    __jsgFetchPatched = true;

    var originalFetch = window.fetch;
    if (!originalFetch) return;

    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';
        var isAdd = url && url.indexOf('/cart/add') !== -1;

        jsgInitRefs(true);
        var cfg = jsgRefs.cfg || {};

        if (isAdd && jsgShouldAutoTagFromUrl(cfg) && init && init.body) {
          // Handle FormData
          if (window.FormData && init.body instanceof FormData) {
            if (!init.body.has('properties[_spend_gift]')) init.body.append('properties[_spend_gift]', '1');
            if (!init.body.has('properties[_spend_gift_collection]')) init.body.append('properties[_spend_gift_collection]', String(cfg.collection_handle || ''));
          }
          // Handle JSON body
          else if (typeof init.body === 'string' && init.headers) {
            var ct = '';
            try {
              ct = (init.headers['Content-Type'] || init.headers['content-type'] || '');
            } catch (_) {}

            if (ct.indexOf('application/json') !== -1) {
              try {
                var obj = JSON.parse(init.body);
                obj.properties = obj.properties || {};
                if (obj.properties._spend_gift == null) obj.properties._spend_gift = '1';
                if (obj.properties._spend_gift_collection == null) obj.properties._spend_gift_collection = String(cfg.collection_handle || '');
                init.body = JSON.stringify(obj);
              } catch (e) {}
            }
          }
        }
      } catch (e) {}

      return originalFetch.apply(this, arguments);
    };

    jsgTrace('fetch patched for /cart/add.js auto-tagging');
  }

  /* ===== 10) RENDER ===== */
  function jsgRenderHidden() {
    if (!jsgRefs.unlock) return;
    if (jsgRefs.msg) jsgRefs.msg.innerHTML = '';
    jsgHideSection(jsgRefs.unlock);
  }

  function jsgRenderVisible(eligibleQty, remaining, productName) {
    if (!jsgRefs.unlock) return;

    var cfg = jsgRefs.cfg || {};
    var tpl = String(cfg.message_tpl || 'You got %qty% free gifts from %product%. You have %remaining% left to choose.');
    var msg = jsgApplyTemplate(tpl, { qty: eligibleQty, remaining: remaining, product: productName });

    if (jsgRefs.msg) {
      // Keep same style as cart rewards: title-like bold
      jsgRefs.msg.innerHTML = '<strong>' + msg + '</strong>';
    }

    // Ensure CTA url includes jsg=1 so collection page tagging activates
    if (jsgRefs.btn && cfg && cfg.collection_url) {
      var href = String(cfg.collection_url);
      href += (href.indexOf('?') === -1 ? '?' : '&') + 'jsg=1';
      jsgRefs.btn.href = href;

      if (cfg.cta) jsgRefs.btn.textContent = String(cfg.cta);
      jsgRefs.btn.setAttribute('aria-label', jsgRefs.btn.textContent || 'Choose gift');
    }

    jsgShowSection(jsgRefs.unlock);
  }

  /* ===== 11) MAIN REFRESH ===== */
  function jsgRefresh(force) {
    var now = Date.now();
    if (!force && now - __jsgLastRunAt < 120) return;
    __jsgLastRunAt = now;

    if (__jsgIsRunning) { jsgTrace('refresh skipped (in flight)'); return; }
    __jsgIsRunning = true;

    jsgInitRefs(true);

    if (!jsgRefs.container || !jsgRefs.cfg || !jsgRefs.unlock) {
      __jsgIsRunning = false;
      return;
    }

    var cfg = jsgRefs.cfg;
    var allowed = jsgAccessAllowed(cfg.access, cfg.customer_logged);

    if (!allowed) {
      jsgTrace('access blocked', cfg.access, cfg.customer_logged);
      jsgRenderHidden();
      __jsgIsRunning = false;
      return;
    }

    if (!cfg.collection_url || !cfg.collection_handle || !Array.isArray(cfg.tiers)) {
      jsgTrace('missing config fields', cfg);
      jsgRenderHidden();
      __jsgIsRunning = false;
      return;
    }

    Promise.all([
      jsgGetCart(),
      jsgFetchCollectionProducts(cfg.collection_handle)
    ]).then(function (res) {
      var cart = res[0];
      var col = res[1];

      var spendTotal = jsgGetSpendSubtotal(cart);
      var eligibleQty = jsgResolveEligibleQty(spendTotal, cfg.tiers, cfg.max_qty);

      var claimedQty = (eligibleQty > 0) ? jsgCountClaimedQtyFromCollection(cart, col.handlesMap) : 0;
      var remaining = Math.max(eligibleQty - claimedQty, 0);

      var productName = String(cfg.product_name || cfg.collection_title || cfg.collection_handle || 'gift');

      jsgTrace('refresh', {
        item_count: cart.item_count,
        subtotal_excl_rewards: spendTotal,
        eligible_qty: eligibleQty,
        claimed_qty_from_collection: claimedQty,
        remaining: remaining
      });

      // Hide if not qualified OR fully claimed
      if (eligibleQty > 0 && remaining > 0) jsgRenderVisible(eligibleQty, remaining, productName);
      else jsgRenderHidden();

    }).catch(function (e) {
      jsgLog('error', 'jsgRefresh failed', e);
    }).finally(function () {
      __jsgIsRunning = false;
    });
  }

  /* ===== 12) EVENT LISTENERS ===== */
  var __jsgListenersAttached = false;

  function jsgAttachListeners() {
    if (__jsgListenersAttached) return;
    __jsgListenersAttached = true;

    var names = [
      'cart:updated', 'cart:change', 'cart:refresh',
      't4s:cart:updated', 't4s:cart:change',
      'ajaxCart:updated', 'ajaxProduct:added',
      'added.ajaxProduct', 'removed.ajaxProduct',
      'jcg:gifts'
    ];

    names.forEach(function (n) {
      document.addEventListener(n, function () {
        jsgDebouncedRefresh(120);
      }, { passive: true });
    });
  }

  /* ===== 12b) GLOBAL CART EVENT LOGGER (DIAG) ===== */
  var __jsgCartEventLoggerAttached = false;

  function jsgAttachCartEventLogger() {
    if (__jsgCartEventLoggerAttached) return;
    __jsgCartEventLoggerAttached = true;

    var names = [
      'cart:updated', 'cart:change', 'cart:refresh',
      't4s:cart:updated', 't4s:cart:change',
      'ajaxCart:updated', 'ajaxProduct:added',
      'added.ajaxProduct', 'removed.ajaxProduct',
      'jcg:gifts'
    ];

    function safeDetail(d) {
      try { return d == null ? null : JSON.parse(JSON.stringify(d)); }
      catch (_) { return d; }
    }

    names.forEach(function (n) {
      document.addEventListener(n, function (e) {
        console.log('[CART EVENT]', n, {
          time: new Date().toISOString(),
          detail: safeDetail(e && e.detail)
        });
      }, { passive: true });
    });

    console.log('[JSG] Cart event logger attached:', names);
  }

  /* ===== 13) DIAGNOSTIC INSPECTOR ===== */
  window.__jsgDiag = function () {
    jsgInitRefs(true);
    var info = {
      hasContainer: !!jsgRefs.container,
      hasCfg: !!jsgRefs.cfg,
      cfg: jsgRefs.cfg,
      hasUnlock: !!jsgRefs.unlock,
      hasMsg: !!jsgRefs.msg,
      hasBtn: !!jsgRefs.btn
    };
    console.log('[JSG:DIAG]', info);
    return info;
  };

  /* ===== 14) BOOT ===== */
  document.addEventListener('DOMContentLoaded', function () {
    jsgInitRefs(true);
    jsgAttachListeners();
    jsgAttachCartEventLogger();

    // Auto-tagging helpers (works on collection/product pages too)
    jsgPatchFetchAddToCart();
    jsgInjectIntoForms();

    jsgRefresh(true);
  });

})();
